import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {
    useGetAdvancedSearchDancesQuery,
    useGetArtistsQuery,
    useI18n,
} from 'store/Store.js'
import {useGetChoreographersQuery} from 'store/slices/api/choreographersApi.js'
import {useDebounce} from 'use-debounce'

const useAdvancedSearch = () => {
    const {i18n} = useI18n()
    const navigate = useNavigate()

    const [searchTerm, setSearchTerm] = useState('')
    const [debouncedSearchTerm] = useDebounce(searchTerm, 300)

    const [choreographerName, setChoreographerName] = useState('')
    const [debouncedChoreographerName] = useDebounce(choreographerName, 300)
    const [selectedChoreographer, setSelectedChoreographer] = useState(null)

    const [artistName, setArtistName] = useState('')
    const [debouncedArtistName] = useDebounce(artistName, 300)

    const [selectedArtist, setSelectedArtist] = useState(null)
    const [selectedStyles, setSelectedStyles] = useState([])

    const {data: choreographers, isLoading: isChoreographers} =
        useGetChoreographersQuery(debouncedChoreographerName)

    const {data: artists, isLoading: isArtistsLoading} =
        useGetArtistsQuery(debouncedArtistName)

    const {data: dances, isLoading} = useGetAdvancedSearchDancesQuery({
        name: debouncedSearchTerm,
        artist: selectedArtist,
        choreographer: selectedChoreographer,
        styles: selectedStyles,
    })

    const handleChange = (setter) => (_, newValue) => {
        setter(newValue)
    }

    const handleDanceNameChange = (event) => {
        setSearchTerm(event.target.value)
    }
    const handleRowClick = ({_id}) => {
        navigate(`/dance/${_id}`)
    }
    const t = (label) => i18n.t(`advancedSearch.${label}`)

    const t18AdvancedSearch = (text) => i18n.t(`advancedSearch.${text}`)

    const columns = [
        {id: 'name', label: t('name')},
        {id: 'performer', label: t('performer')},
        {id: 'choreographers', label: t('choreographers')},
        {id: 'composers', label: t('composers')},
        {id: 'lyricists', label: t('lyricists')},
        {id: 'style', label: t('style')},
    ]

    const rows = dances
        ? dances.map((dance) => ({
              name: dance.name,
              performer: dance.performer,
              choreographers: dance.creators
                  .map((creator) => creator.fullName)
                  .join(', '),
              composers: dance.song.composers
                  .map((composer) => composer.hebName)
                  .join(', '),
              lyricists: dance.song.lyricists
                  .map((lyricist) => lyricist.hebName)
                  .join(', '),
              style: dance.style,
              _id: dance._id,
          }))
        : []

    return {
        searchTerm,
        selectedStyles,
        choreographers,
        artists,
        dances,
        isLoading,
        isArtistsLoading,
        isChoreographers,
        handleDanceNameChange,
        handleStyleChange: handleChange(setSelectedStyles),
        handleArtistChange: handleChange(setArtistName),
        handleArtistSelected: handleChange(setSelectedArtist),
        handleChoreographerChange: handleChange(setChoreographerName),
        handleChoreographerSelected: handleChange(setSelectedChoreographer),
        rows,
        columns,
        handleRowClick,
        t18AdvancedSearch,
    }
}

export default useAdvancedSearch
